<template>
	<div>
        <div v-show="show">
            <div class="text-primaryGrey mb-3">
                <v-row no-gutters>
                    <v-col cols="auto">
                        <div class="d-flex flex-wrap">
                            <div class="body-text-btn d-flex align-center">
                                <v-icon v-if="currencyIcon" size="24" class="mr-2">
                                    <v-img :src="currencyIcon"></v-img>
                                </v-icon>
                                <div>{{ paymentToken == null ? '--/--' : `${currency}/${paymentToken}` }}</div>
                            </div>
                        </div>
                        <div v-if="address" class="text-primaryGrey gradient-underline-hover mt-2">
                            <span>Token Contract: </span>
                            <a :href="addressUrl" target="_blank" class="text-primaryGrey gradient-text-hover pointer">{{ address }}</a>
                        </div>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto" class="text-right" :class="[currentPriceTextColor]" justify="end">
                        <div class="body-text-btn">${{ $tools.formatNumber(currentPrice) }}</div>
                        <div v-if="todayPriceChange != null" class="fs-12 font-weight-bold mt-2">{{ todayPriceChange?.priceChange >= 0 ? '+' : '' }}{{ $tools.formatNumber(todayPriceChange?.priceChange) }} ({{ todayPriceChange?.priceChangePercent >= 0 ? '+' : '' }}{{ $tools.formatNumber(todayPriceChange?.priceChangePercent) }}%) today</div>
                    </v-col>
                </v-row>
            </div>
            <div :id="id" style="width: 100%; position: relative;" :style="{ height: responsive == 'pc' ? '480px' : '240px' }"></div>
        </div>
	</div>
</template>
<script>
import { mapGetters } from "vuex";
import IoBotsAPI from '@/api/ioBots.js';
import PriceAPI from '@/api/price.js';
export default {
    data(){
        return {
            id: `underlyingPriceLineChart-${+new Date()}`,
            // 是否展示图表
            show: true,
            priceLineChart: null,
            paymentToken: null,
            lastPrice: 0,
            todayPriceChange: null,
            option : {
                xAxis: {
                    type: 'category',
                    axisTick: {
                        show: false
                    },
                    splitLine:{
                        show: false
                    },
                    axisLine: {
                        show: false
                    },
                    axisLabel: {
                        show: true,
                        showMaxLabel: true,
                        alignMinLabel: 'left',
                        showMaxLabel: true,
                        alignMaxLabel: 'right'
                    },
                    data: [],
                },
                grid: {
                    left: '0%',
                    right: '0%',
                    top: '10%',
                    bottom: '10%',
                    containLabel: true
                },
                yAxis: {
                    type: 'log',
                    axisTick: {
                        show: false,
                    },
                    splitLine:{
                        show: false
                    },
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        show: true,
                        align: "right",
                        formatter: function (value, index) {
                            return value.toFixed(2);
                        }
                    },
                    scale: true
                },
                series: [{
                    data: [],
                    type: 'line',
                    smooth: true,
                    symbol: 'none',
                    lineStyle: {
                        color: '#03DAC5',
                        width: 5
                    },
                }]
            },
            currencies: [
                { currency: 'BTC', icon: 'https://imagedelivery.net/P4z5C24T1A4q673nx_eYTw/b5847ad9-b2bf-491d-6a86-3d9d057d3500/public' },
                { currency: 'ETH', icon: 'https://imagedelivery.net/P4z5C24T1A4q673nx_eYTw/910c7fc2-83fe-4178-7f0f-5fb45f413500/public' },
                { currency: 'SOL', icon: 'https://imagedelivery.net/P4z5C24T1A4q673nx_eYTw/55dbc288-bf5c-4f71-fe33-f1c222388300/public' },
                { currency: 'LINK', icon: 'https://imagedelivery.net/P4z5C24T1A4q673nx_eYTw/edc96e8e-432c-4f73-3e4e-f7c88b2efb00/public' },
                { currency: 'UNI', icon: 'https://imagedelivery.net/P4z5C24T1A4q673nx_eYTw/9305484c-532d-4d15-6dc1-ccadc99db900/public' },
                { currency: 'UN', icon: 'https://imagedelivery.net/P4z5C24T1A4q673nx_eYTw/8d5cfb8b-4b67-4b8b-00b8-ed4187d98600/public' },
                { currency: 'UN²', icon: 'https://imagedelivery.net/P4z5C24T1A4q673nx_eYTw/421fb238-27d5-4619-4df1-e6bd427acb00/public' },
            ]
        }
    },
    props: {
        // 货币
        currency: {
            type: String,
            default: null
        },
        // 地址
        address: {
            type: String,
            default: null
        },
        // 地址链接
        addressUrl: {
            type: String,
            default: null
        },
    },
    components: {  },
    created() {
      this.$nextTick(() => {
        this.initFN();
      });
    },
    mounted(){
        // 1分钟轮询更新货币价格
        setInterval(() => {
            // 查询货币今日价格变动
            this.getTodayPriceChange();
        }, 1000 * 60 * 1);
    },
    computed: {
        ...mapGetters(['responsive', 'darkTheme', 'prices']),
        currencyIcon() {
            return this.currencies.filter(c => c.currency == this.currency)[0]?.icon || null;
        },
        // 当前价格
        currentPrice() {
            if(this.todayPriceChange != null && this.todayPriceChange?.currentPrice > 0) {
                return this.todayPriceChange?.currentPrice;
            }
            return this.prices.filter(P => P.currency == this.currency)[0]?.price || 0;
        },
        // 当前价格颜色
        currentPriceTextColor() {
            if (this.currentPrice == 0 || this.todayPriceChange == null || this.todayPriceChange?.priceChange == 0) {
                return '';
            }
            return this.todayPriceChange?.priceChange > 0 ? 'text-green-500' : 'text-red-500';
        },
    },
    watch:{
        // darkTheme(val) {
        //     // this.option.series[0].lineStyle.color = this.darkTheme == 0 ? '#95c8ff':'#004080';
        //     // 查询货币价格历史图表
        //     this.getPriceHistories();
        // },
        currency: {
            async handler(newVal, oldVal) {
                // 查询货币今日价格变动
                await this.getTodayPriceChange();
                // 查询货币价格历史图表
                await this.getPriceHistories();
            },
            immediate: true
        },
    },
    methods: {
      // 初始化
      initFN() {
        var that = this;
        // 渲染图表
        this.priceLineChart = this.$echarts.init(document.getElementById(this.id));
        // 填充数据
        this.priceLineChart.setOption(this.option, true);
        this.priceLineChart.on('click', function(series) {

        })
      },
      // 查询货币今日价格变动
      async getTodayPriceChange() {
        if (this.currency == null) {
            return;
        }
        let res = await PriceAPI.getTodayPriceChange(this.currency);
        let data = res.data;
        if(data.code == 200) {
            this.todayPriceChange = data.data;
        }
      },
      // 查询货币价格历史图表
      async getPriceHistories() {
        if (this.currency == null) {
            return;
        }
        let res = await IoBotsAPI.getPriceHistories(this.currency);
        let data = res.data;
        if (data.code == 200) {
            let result = data.data;
            this.paymentToken = result.paymentToken;
            let currentDates = [];
            let currentValues = [];
            for (let i = 0, len = result.date.length; i < len; i++) {
                let isHalfYearStart = this.$tools.isHalfYearStart(result.date[i]);
                if(isHalfYearStart) {
                    currentDates.push(this.$tools.formatSeparatorDate(result.date[i]));
                    currentValues.push(result.data[i]);
                }
            }
            // 再放入最后一天的数据
            currentDates.push(this.$tools.formatSeparatorDate(result.date[result.date.length - 1]));
            this.lastPrice = result.data[result.data.length - 1];
            currentValues.push(this.lastPrice);
            // 在放入当前实时数据
            if (this.currentPrice != 0) {
                let date = new Date();
                let month = (date.getMonth() + 1).toString().padStart(2, '0');
                let day = date.getDate().toString().padStart(2, '0');
                let todayDate = `${month}/${day}/${date.getFullYear()}`;
                currentDates.push(todayDate);
                currentValues.push(this.currentPrice);
            }
            this.option.xAxis.data = currentDates;
            this.option.series[0].data = currentValues;
            // this.option.series[0].lineStyle.color = this.darkTheme == 0 ? '#95c8ff':'#004080';
        } else {
            // 查询失败不显示图表
            this.show = false;
        }
        // 填充数据
        this.priceLineChart.setOption(this.option, true);
      },
    }
}
</script>
<style lang="scss" scoped>
// .priceLineChart {
//     width: 100%;
//     height: 486px;
// }
</style>